/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  EventActionResourceReport,
  PackagesCount,
  PackageType,
} from "~/generated/graphql";

export type ReportState = {
  resources?: EventActionResourceReport[];
  searchQuery?: string;
  eventActionId: string;
  filterQuery: FilterType;
  packagesCount?: Omit<PackagesCount, "packages">;
};

export enum FilterType {
  ALL = "ALL",
  INSTALLED = "INSTALLED",
  INSTALLED_PENDING_REBOOT = "INSTALLED_PENDING_REBOOT",
  UPDATED = "UPDATED",
  AVAILABLE = "AVAILABLE",
  REMOVED = "REMOVED",
  FAILED = "FAILED",
}

export type EventActionResourceReportsQuery = {
  packageTypes?: PackageType[];
  logOutputs?: string[];
};
